import React from 'react';

import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;

  & + & {
    margin-top: 8px;
  }

  img {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
    opacity: 0.3;
  }
`;

export const Input = styled.input<{ disabled?: boolean; error?: string; height?: string }>`
  width: 100%;
  height: ${({ height }) => (height ? height : '48px')};
  overflow: hidden;
  display: flex;
  flex-flow: column nowrap;
  border-radius: 4px;
  color: var(--colorBlueGray1200);
  background-color: var(--colorBlueGray50);
  border: 1px solid ${({ error }) => (error ? 'var(--colorWarning)' : 'rgb(213, 215, 216)')};
  padding: 7px 16px 9px;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: var(--letterSpacing);
  line-height: 20px;
  outline: none;
  transition: border-color 0.2s ease-in-out;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};

  &:focus {
    border-color: var(--colorBlueGray1200) !important;
  }
`;

export const Currency = styled.span`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  position: absolute;
  right: 18px;
  line-height: var(--lineHeightSmall);
  top: 50%;
  letter-spacing: var(--letterSpacing);
  transform: translateY(-50%);
  color: var(--colorBlueGray800);
`;
